import { OccupationItemsWithFormattedDates } from 'pages/candidateOffer/types';
import IconRow from 'pages/candidateOfferList/components/OfferDescription/IconRow';
import { CalendarIcon } from 'pages/candidateOfferList/img';
import React from 'react';
import styled from 'styled-components';

interface OfferSingleItemScheduleListProps {
    item: OccupationItemsWithFormattedDates;
}

export default function OfferSingleItemScheduleList({ item }: OfferSingleItemScheduleListProps) {
    const content = item.startTzStr && item.finishTzStr
        ? `${ item.dateStr }, ${ item.startTzStr } - ${ item.finishTzStr }`
        : item.dateStr;

    return (
        <StyledIconRow
            icon={ <CalendarIcon /> }
            content={ content }
        />
    );
}

const StyledIconRow = styled(IconRow)`
    padding-top: ${ ({ theme }) => theme.size.size_10 };
`;
